import { Type } from "class-transformer";
import { keyBy } from "lodash";

import { BasePeriodCondition } from "./BaseCondition/BasePeriodCondition";
import { DateInterval } from "./DateInterval/DateInterval";
import { DateIntervalBuilder } from "./DateInterval/DateIntervalBuilder";
import { DayOfMonth } from "./DayOfMonth/DayOfMonth";
import { DayOfMonthBuilder } from "./DayOfMonth/DayOfMonthBuilder";
import { DayOfWeek } from "./DayOfWeek/DayOfWeek";
import { DayOfWeekBuilder } from "./DayOfWeek/DayOfWeekBuilder";
import { TimeInterval } from "./TimeInterval/TimeInterval";
import { TimeIntervalBuilder } from "./TimeInterval/TimeIntervalBuilder";
import { PeriodConditionsTypeEnum } from "./types";

export class PeriodConditions {

  @Type(() => BasePeriodCondition, {
    discriminator: {
      property: 'type',
      subTypes: [
        { name: PeriodConditionsTypeEnum.TimeInterval, value: TimeInterval },
        { name: PeriodConditionsTypeEnum.DateInterval, value: DateInterval },
        { name: PeriodConditionsTypeEnum.DayOfMonth, value: DayOfMonth },
        { name: PeriodConditionsTypeEnum.DayOfWeek, value: DayOfWeek },
      ]
    },
    keepDiscriminatorProperty: true
  })
  conditions!: Array<BasePeriodCondition>

  removeCondition(condition: BasePeriodCondition, index?: string | number) {
    condition.removeValue(condition, index)

    this.removeIfEmpty(condition)
  }

  removeIfEmpty(condition: BasePeriodCondition) {
    if (condition.isEmpty()) {
      this.conditions = this.conditions.filter(c => c.type !== condition.type)
    }
  }

  addCondition(newCondition: BasePeriodCondition) {
    return newCondition.validate()
      .then(res => {
        if (res) {
          if (newCondition.isEmpty()) {
            this.removeCondition(newCondition)
          } else {
            const existedCondition = this.conditions.find(c => c.type === newCondition.type)

            if (!existedCondition) {
              this.conditions.push(newCondition)
            } else {
              existedCondition.addValue(newCondition)
            }
          }

          return true
        }

        return false
      })
  }

  conditionExist(type: PeriodConditionsTypeEnum) {
    return this.conditions.find(c => c.type === type)
  }
}

export const periodConditionsBuilders = keyBy([
  TimeIntervalBuilder,
  DateIntervalBuilder,
  DayOfWeekBuilder,
  DayOfMonthBuilder,
], 'type')
